import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminState } from './type';

const initialState: AdminState = {
  id: undefined,
  email: undefined,
  isSuperAdmin: false,
};

const adminSlice = createSlice({
  name: 'auth/admin',
  initialState,
  reducers: {
    setSuperAdmin: (_: AdminState, action: PayloadAction<AdminState>) => action.payload,
    adminLoggedOut: () => initialState,
  },
  extraReducers: {},
});

export const { setSuperAdmin, adminLoggedOut } = adminSlice.actions;

export default adminSlice.reducer;
